import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import {
  PhoneIphone as PhoneIphoneIcon,
  Email as EmailIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import EditIcon from "../../../assets/icons/edit.svg";
import AppIcon from "../../common/AppIcon";
import CustomIcon from "../../common/CustomIcon";
import AppSnackbar from "../../common/AppSnackbar";
import AppModal from "../../common/AppModal";
import EditInfoModal from "./edit-info-modal";
import usePermissions from "../../../hooks/usePermissions";
import { getStaffImage } from "../../../utils/utils";
import { ButtonTitles } from "../../../utils/constants";

export const StyledBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
interface IProps {
  profileData: any;
  clinicId: string;
  getProfileData: () => void;
  queryId: any;
}
const StaffInfoCard = ({
  profileData,
  clinicId,
  getProfileData,
  queryId,
}: IProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const isPermissions = usePermissions();
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  return (
    <>
      <Box
        sx={{
          py: 4,
          px: 5,
          position: "relative",
          bgcolor: "white",
        }}
      >
        <Grid container spacing={3}>
          {/* <Grid item>
            <Avatar
              alt={profileData?.name}
              sx={{ width: 170, height: 170 }}
              src={getStaffImage(
                profileData?.id,
                clinicId,
                profileData?.profile_picture_url
              )}
            />
          </Grid>
          <Grid item>
            <Typography
              sx={{
                color: "secondary.main",
                fontWeight: "600",
                fontSize: "28px",
              }}
              variant="h4"
            >
              Name :{profileData?.name}
            </Typography>
            <Typography
              sx={{ mt: 1, fontWeight: "600", fontSize: "18px", mb: 5 }}
              variant="h6"
            >
              Designation: {profileData?.designation}
            </Typography>

            <Grid container spacing={3}>
              <Grid item>
                <Box sx={{ display: "flex" }}>
                  <AppIcon IconType={PhoneIphoneIcon} />
                  <Box sx={{ display: "flex", flexDirection: "column", pl: 2 }}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                      }}
                    >
                      Mobile
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      Phone No :{profileData?.phone_number}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item>
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ height: "100%" }}
                />
              </Grid>
              <Grid item>
                <Box sx={{ display: "flex" }}>
                  <AppIcon IconType={EmailIcon} />
                  <Box sx={{ display: "flex", flexDirection: "column", pl: 2 }}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                      }}
                    >
                      Email
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      {profileData?.email}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid> */}
          <Grid item>
          
              <CustomIcon
                style={{
                  position: "absolute",
                  right: 15,
                  top: 15,
                  cursor: "pointer",
                }}
                IconType={EditIcon}
                title={ButtonTitles.Edit.title}
                onClick={handleOpenModal}
              />
                        
          </Grid>
        </Grid>
      </Box>

      <AppModal
        title="Profile"
        fullScreen={false}
        open={openModal}
        handleClose={handleCloseModal}
        maxWidth="sm"
      >
        <EditInfoModal
          handleClose={handleCloseModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
          getProfileData={getProfileData}
          profileInfo={profileData}
          clinicId={clinicId}
          queryId={queryId}
        />
      </AppModal>
      <AppSnackbar
        message="Updated successfully!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};

export default StaffInfoCard;
